import { render, staticRenderFns } from "./JsonCompare.vue?vue&type=template&id=12e099cf&"
import script from "./JsonCompare.vue?vue&type=script&lang=js&"
export * from "./JsonCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports